import React, { useState, useEffect, useContext } from 'react';
import apiService from '../../services/apiService';
import Loader from '../../CommanService/Loader';
import { SelectionContext } from './ControlBar';

const PriceLineConfigTab = () => {
  const { selectedPartType } = useContext(SelectionContext);
  const displayedPartType = (selectedPartType || 'ENGINE');

  const [priceLineConfig, setPriceLineConfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    understocked_q1: '',
    understocked_q2: '',
    understocked_q3: '',
    understocked_q4: '',
    adequately_stocked_q1: '',
    adequately_stocked_q2: '',
    adequately_stocked_q3: '',
    adequately_stocked_q4: '',
    overstocked_q1: '',
    overstocked_q2: '',
    overstocked_q3: '',
    overstocked_q4: ''
  });

  // State for TB Groups and Variables
  const [tbGroups, setTbGroups] = useState([]);
  const [tbVariables, setTbVariables] = useState([]);
  const [supplyVariables, setSupplyVariables] = useState([]);
  const [demandVariables, setDemandVariables] = useState([]);
  const [othersVariables, setOthersVariables] = useState([]);
  
  // State for weightage form data
  const [weightageFormData, setWeightageFormData] = useState({});

  // New: Fetch TB Groups
  const fetchTBGroups = async () => {
    try {
      setLoading(true);
      const res = await apiService.GetAllTbGroup();
      console.log('TB Groups:', res);
      if (res && Array.isArray(res.data)) {
        setTbGroups(res.data);
      }
    } catch (err) {
      console.error('Failed to fetch TB Groups:', err);
    } finally {
      setLoading(false);
    }
  };

  // New: Fetch TB Variables
  const fetchTBVariables = async () => {
    try {
      setLoading(true);
      const res = await apiService.GetAllTBVariables();
      if (res && Array.isArray(res.data)) {
        setTbVariables(res.data);
      } else if (res && Array.isArray(res)) {
        // If response is directly an array
        setTbVariables(res);
      }
    } catch (err) {
      console.error('Failed to fetch TB Variables:', err);
    } finally {
      setLoading(false);
    }
  };

  // Filter variables by group_id
  const filterVariablesByGroup = () => {
    debugger;
    if (tbGroups.length > 0 && tbVariables.length > 0) {
      console.log('Filtering variables by group...');
      console.log('TB Groups:', tbGroups);
      console.log('TB Variables:', tbVariables);
      
      // Get group IDs dynamically from TB Groups
      const supplyGroup = tbGroups.find(group => group.group_name === 'Supply');
      const demandGroup = tbGroups.find(group => group.group_name === 'Demand');
      const othersGroup = tbGroups.find(group => group.group_name === 'Miscellaneous');
      
      console.log('Found Groups:', {
        supply: supplyGroup,
        demand: demandGroup,
        others: othersGroup
      });
      
      // Filter Supply variables using dynamic group_id
      const supply = supplyGroup ? tbVariables.filter(variable => variable.group_id === supplyGroup.id) : [];
      setSupplyVariables(supply);
      console.log('Supply Variables (group_id: ' + (supplyGroup?.id || 'not found') + '):', supply);
      console.log('Supply Variables weightage values:', supply.map(v => ({ name: v.variable_name, weightage: v.weightage })));
      console.log('Supply Variables Array Length:', supply.length);
      console.log('First Supply Variable:', supply[0]);
      console.log('All Supply Variables:', supply);
      
      // Filter Demand variables using dynamic group_id
      const demand = demandGroup ? tbVariables.filter(variable => variable.group_id === demandGroup.id) : [];
      setDemandVariables(demand);
      console.log('Demand Variables (group_id: ' + (demandGroup?.id || 'not found') + '):', demand);
      console.log('Demand Variables weightage values:', demand.map(v => ({ name: v.variable_name, weightage: v.weightage })));
      
      // Filter Others variables using dynamic group_id
      const others = othersGroup ? tbVariables.filter(variable => variable.group_id === othersGroup.id) : [];
      setOthersVariables(others);
      console.log('Others Variables (group_id: ' + (othersGroup?.id || 'not found') + '):', others);
      console.log('Others Variables weightage values:', others.map(v => ({ name: v.variable_name, weightage: v.weightage })));
      
      // Summary
      console.log('Grouped Variables Summary:');
      console.log('- Supply Variables Count:', supply.length);
      console.log('- Demand Variables Count:', demand.length);
      console.log('- Others Variables Count:', others.length);
    }
  };

  // Initialize weightage form data when variables are loaded
  const initializeWeightageFormData = () => {
    const allVariables = [
      ...supplyVariables,
      ...demandVariables,
      ...othersVariables
    ];
    
    console.log('Initializing weightage form data with allVariables:', allVariables);
    
    const initialData = {};
    allVariables.forEach(variable => {
      console.log('Processing variable:', variable);
      if (variable.variable_code && variable.weightage !== undefined) {
        initialData[variable.variable_code] = variable.weightage;
        console.log(`Setting ${variable.variable_code} = ${variable.weightage}`);
      } else {
        console.log(`Skipping variable ${variable.variable_code} - weightage: ${variable.weightage}`);
      }
    });
    
    console.log('Final initialData:', initialData);
    setWeightageFormData(initialData);
  };


  
  useEffect(() => {
    const fetchPriceLineConfig = async () => {
      setLoading(true);
      try {
        const res = await apiService.GetPriceLineConfig();
        setPriceLineConfig(res.data);
      } catch (err) {
        console.error('Failed to fetch price line config:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPriceLineConfig();
    fetchTBGroups();
    fetchTBVariables();
  }, []);

  // Populate form data whenever config or selected part type changes
  useEffect(() => {
    debugger
    if (!priceLineConfig || priceLineConfig.length === 0) return;
    const activePartType = selectedPartType || 'ENGINE';
    const filteredItems = priceLineConfig.filter(
      (item) => String(item.part_type).toUpperCase() === String(activePartType).toUpperCase()
    );
    const filteredData = {};
    filteredItems.forEach((item) => {
      const key = `${item.stock_status.toLowerCase().replace(' ', '_')}_${item.quartile_name.toLowerCase()}`;
      filteredData[key] = item.quartile_value;
    });
    setFormData(filteredData);
  }, [priceLineConfig, selectedPartType]);

  // Filter variables when both groups and variables are loaded
  useEffect(() => {
    console.log('Filtering variables - tbGroups:', tbGroups);
    console.log('Filtering variables - tbVariables:', tbVariables);
    filterVariablesByGroup();
  }, [tbGroups, tbVariables]);

  // Initialize weightage form data when variables are filtered
  useEffect(() => {
    console.log('Variables changed - supply:', supplyVariables.length, 'demand:', demandVariables.length, 'others:', othersVariables.length);
    if (supplyVariables.length > 0 || demandVariables.length > 0 || othersVariables.length > 0) {
      console.log('Calling initializeWeightageFormData');
      initializeWeightageFormData();
    }
  }, [supplyVariables, demandVariables, othersVariables]);

  // Debug: Log when variables are set
  useEffect(() => {
    console.log('Current supplyVariables:', supplyVariables);
    console.log('Current demandVariables:', demandVariables);
    console.log('Current othersVariables:', othersVariables);
    console.log('Current weightageFormData:', weightageFormData);
  }, [supplyVariables, demandVariables, othersVariables, weightageFormData]);

  




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWeightageInputChange = (e) => {
    const { name, value } = e.target;
    setWeightageFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit1 = async (e) => {
    e.preventDefault();
    
    // Create array of objects filtered by selected part type from the original API data with updated values
    const activePartType = selectedPartType || 'ENGINE';
    const quartileData = priceLineConfig
      .filter((item) => String(item.part_type).toUpperCase() === String(activePartType).toUpperCase())
      .map((item) => {
        const key = `${item.stock_status.toLowerCase().replace(' ', '_')}_${item.quartile_name.toLowerCase()}`;
        const value = formData[key];
        return {
          id: item.id,
          stock_status: item.stock_status,
          quartile_name: item.quartile_name,
          quartile_value: value !== undefined && value !== null ? parseInt(value) : item.quartile_value,
          part_type: item.part_type
        };
      });
    try {
      setLoading(true);
      const response = await apiService.UpdatePriceLineConfig(quartileData);
    } catch (error) {
      console.error('Update failed:', error);
    } finally {
     setLoading(false);
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();
    // Collect all variables
    const allVariables = [
      ...supplyVariables,
      ...demandVariables,
      ...othersVariables
    ];
    // Build the array of objects
    const result = allVariables.map(variable => ({
      id: variable.id,
      variable_name: variable.variable_name,
      group_id: variable.group_id,
      variable_code: variable.variable_code,
      weightage: weightageFormData[variable.variable_code] !== undefined ? weightageFormData[variable.variable_code] : variable.weightage
    }));
    console.log('Weightage Submission:', result);
    try {
      setLoading(true);
      const response = await apiService.UpdateTbGroup(result);
      console.log('UpdateTbGroup API response:', response);
    } catch (error) {
      console.error('UpdateTbGroup API error:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <form onSubmit={handleSubmit1}>
        <div className="control_blk_containers filter_blk mb_15">
          <h3 className="font_16 fw-semi text_black mb_15">Set Global Price Line % by Quartile for Each Stock Status - {displayedPartType}</h3>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Understocked</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q1 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="understocked_q1"
                value={formData.understocked_q1}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q2 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="understocked_q2"
                value={formData.understocked_q2}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q3 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="understocked_q3"
                value={formData.understocked_q3}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q4 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="understocked_q4"
                value={formData.understocked_q4}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Adequately Stocked</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q1 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="adequately_stocked_q1"
                value={formData.adequately_stocked_q1}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q2 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="adequately_stocked_q2"
                value={formData.adequately_stocked_q2}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q3 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="adequately_stocked_q3"
                value={formData.adequately_stocked_q3}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q4 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="adequately_stocked_q4"
                value={formData.adequately_stocked_q4}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Overstocked</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q1 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="overstocked_q1"
                value={formData.overstocked_q1}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q2 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="overstocked_q2"
                value={formData.overstocked_q2}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q3 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="overstocked_q3"
                value={formData.overstocked_q3}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Q4 %</label>
              <input 
                type="number" 
                className="form-control w-100" 
                name="overstocked_q4"
                value={formData.overstocked_q4}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
        {/* <div className="d-flex justify-content-end mb_15">
          <button type="submit" className="clear_btn filter_btn">Save Global Quartile %s</button>
        </div> */}
      </form>

      <form onSubmit={handleSubmit2}>
        <div className="control_blk_containers filter_blk mb_15">
          <h3 className="font_16 fw-semi text_black mb_15">Weightage</h3>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Supply</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Inventory Age %</label>
              <input 
                className="form-control w-100" 
                name="INVTORYAGE"
                value={weightageFormData.INVTORYAGE !== undefined ? weightageFormData.INVTORYAGE : (supplyVariables.find(v => v.variable_code === 'INVTORYAGE')?.weightage !== undefined ? supplyVariables.find(v => v.variable_code === 'INVTORYAGE')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">QOH %</label>
              <input 
                className="form-control w-100" 
                name="QOH"
                value={weightageFormData.QOH !== undefined ? weightageFormData.QOH : (supplyVariables.find(v => v.variable_code === 'QOH')?.weightage !== undefined ? supplyVariables.find(v => v.variable_code === 'QOH')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Location %</label>
              <input 
                className="form-control w-100" 
                name="LOCATION"
                value={weightageFormData.LOCATION !== undefined ? weightageFormData.LOCATION : (supplyVariables.find(v => v.variable_code === 'LOCATION')?.weightage !== undefined ? supplyVariables.find(v => v.variable_code === 'LOCATION')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Lead Time %</label>
              <input 
                className="form-control w-100" 
                name="LEADTIME"
                value={weightageFormData.LEADTIME !== undefined ? weightageFormData.LEADTIME : (supplyVariables.find(v => v.variable_code === 'LEADTIME')?.weightage !== undefined ? supplyVariables.find(v => v.variable_code === 'LEADTIME')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Mileage %</label>
              <input 
                className="form-control w-100" 
                name="MILEAGE"
                value={weightageFormData.MILEAGE !== undefined ? weightageFormData.MILEAGE : (supplyVariables.find(v => v.variable_code === 'MILEAGE')?.weightage !== undefined ? supplyVariables.find(v => v.variable_code === 'MILEAGE')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
          </div>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Demand</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Searches %</label>
              <input 
                className="form-control w-100" 
                name="SEARCHES"
                value={weightageFormData.SEARCHES !== undefined ? weightageFormData.SEARCHES : (demandVariables.find(v => v.variable_code === 'SEARCHES')?.weightage !== undefined ? demandVariables.find(v => v.variable_code === 'SEARCHES')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Cores %</label>
              <input 
                className="form-control w-100" 
                name="CORES"
                value={weightageFormData.CORES !== undefined ? weightageFormData.CORES : (demandVariables.find(v => v.variable_code === 'CORES')?.weightage !== undefined ? demandVariables.find(v => v.variable_code === 'CORES')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Sales %</label>
              <input 
                className="form-control w-100" 
                name="SALES"
                value={weightageFormData.SALES !== undefined ? weightageFormData.SALES : (demandVariables.find(v => v.variable_code === 'SALES')?.weightage !== undefined ? demandVariables.find(v => v.variable_code === 'SALES')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
          </div>
          <h3 className="font_14 fw-semi text_black mb_15 d-block">Others</h3>
          <div className="row control_row">
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Seasonality %</label>
              <input 
                className="form-control w-100" 
                name="SEASONALITY"
                value={weightageFormData.SEASONALITY !== undefined ? weightageFormData.SEASONALITY : (othersVariables.find(v => v.variable_code === 'SEASONALITY')?.weightage !== undefined ? othersVariables.find(v => v.variable_code === 'SEASONALITY')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Direct Fit %</label>
              <input 
                className="form-control w-100" 
                name="DIRECTFIT"
                value={weightageFormData.DIRECTFIT !== undefined ? weightageFormData.DIRECTFIT : (othersVariables.find(v => v.variable_code === 'DIRECTFIT')?.weightage !== undefined ? othersVariables.find(v => v.variable_code === 'DIRECTFIT')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
            <div className="col-md-3">
              <label className="font_14 fw-med text_black mb_5 d-block">Mechanical Fit %</label>
              <input 
                className="form-control w-100" 
                name="MECHANICALFIT"
                value={weightageFormData.MECHANICALFIT !== undefined ? weightageFormData.MECHANICALFIT : (othersVariables.find(v => v.variable_code === 'MECHANICALFIT')?.weightage !== undefined ? othersVariables.find(v => v.variable_code === 'MECHANICALFIT')?.weightage : '')}
                onChange={handleWeightageInputChange}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button type="button" onClick={handleSubmit2} className="clear_btn filter_btn">Save Variable Weightage %s</button>
        </div>
      </form>
    </div>
  );
};
export default PriceLineConfigTab; 